export default (payload) => ({
  type: 'CLEAR_HISTORIES_STATE',
  payload,
});
